import { Layout } from '../../../queries/ats/layout/types';
import { EpisodeTitle, MovieTitle, ProgramTitle, SeriesTitle } from '../../../queries/ats/titles/types/title';
import { TrackerEvent } from '../../interfaces/tracker-event';
import { SectionItemEventProperties } from '../../interfaces/section-item-event';

export class TitleItemClickedEvent implements TrackerEvent<SectionItemEventProperties> {
  public name = 'item_clicked';
  public properties: SectionItemEventProperties;

  constructor(
    item: Layout.SectionItemTitle,
    section: Layout.SectionView,
    page: Layout.PageView,
    pattern: Layout.Pattern,
  ) {
    let properties: SectionItemEventProperties;

    switch (item.title.type) {
      case 'series':
        properties = this.seriesClicked(item.title, section, page, pattern);
        break;
      case 'episode':
        properties = this.episodeClicked(item.title, section, page, pattern);
        break;
      case 'movie':
        properties = this.movieClicked(item.title, section, page, pattern);
        break;
      case 'program':
        properties = this.programClicked(item.title, section, page, pattern);
        break;
    }

    this.properties = properties;
  }

  private seriesClicked(
    title: SeriesTitle,
    section: Layout.SectionView,
    page: Layout.PageView,
    pattern: Layout.Pattern,
  ) {
    return {
      content_title: title.originalTitle,
      item_style: pattern,
      item_type: 'title',
      page_slug: page.slug,
      section_slug: section.slug,
      referral_id: title.series.masterId,
    };
  }

  private episodeClicked(
    title: EpisodeTitle,
    section: Layout.SectionView,
    page: Layout.PageView,
    pattern: Layout.Pattern,
  ) {
    return {
      content_title: title.originalTitle,
      item_style: pattern,
      item_type: 'title',
      page_slug: page.slug,
      section_slug: section.slug,
      referral_id: title.series.masterId,
    };
  }

  private movieClicked(title: MovieTitle, section: Layout.SectionView, page: Layout.PageView, pattern: Layout.Pattern) {
    return {
      content_title: title.originalTitle,
      item_style: pattern,
      item_type: 'title',
      page_slug: page.slug,
      section_slug: section.slug,
      referral_id: title.masterId,
    };
  }

  private programClicked(
    title: ProgramTitle,
    section: Layout.SectionView,
    page: Layout.PageView,
    pattern: Layout.Pattern,
  ) {
    return {
      content_title: title.originalTitle,
      item_style: pattern,
      item_type: 'title',
      page_slug: page.slug,
      section_slug: section.slug,
      referral_id: title.masterId,
    };
  }
}
